import * as Rollbar from 'rollbar';
const env: any = window['__env'];

import {
    Injectable,
    Inject,
    InjectionToken,
    ErrorHandler
} from '@angular/core';

const rollbarConfig = {
    accessToken: '51bcf36cfc7c4ddaa3905746c2554a31', // THIS MUST BE REPLACED WITH THE CORRECT TOKEN
    environment: (env.environment === 'prod' ? 'production' : env.environment),
    enabled: !(env.environment === 'dev' || env.environment === 'development' || env.environment === 'test'),
    captureUncaught: true,
    captureUnhandledRejections: true,
    autoInstrument: {
        network: true,
        log: true,
        dom: false,
        navigation: true,
        connectivity: true
    }
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
    constructor(@Inject(RollbarService) private rollbar: Rollbar) { }

    handleError(err: any): void {
        if (!rollbarConfig.enabled) {
            console.error(err.originalError || err);
        }
        this.rollbar.error(err.originalError || err);
    }
}

export function rollbarFactory() {
    return new Rollbar(rollbarConfig);
}
